import service from '../../services/cliente/subscription'

const getDefaultState = () => ({
  subscription: {
    doc: {},
    next: null,
    freq: null
  },

  list: [],
  bitacora: [],
  currentRow: null
})

export const state = () => getDefaultState()

export const mutations = {
  SET_LIST: (state, res) => {
    state.list = res
  },
  SET_BITACORA: (state, res) => {
    state.bitacora = res
  },
  SET_ITEM: (state, item) => {
    state.subscription = item
  },
  SET_ROW: (state, row) => (state.currentRow = row),
  DELETE_LIST: (state, obj) => {
    if (obj.isDelete) state.list = state.list.filter(e => e._id !== obj.i._id)
    else {
      const item = state.list.find(e => e._id === obj.i._id)

      item.state = false
    }
  },
  RESET_STATE: state => Object.assign(state, getDefaultState())
}
export const actions = {
  subscribe: async ({}, { _id, input }) => service.subscribe(_id, input),
  readSubscriptionsByCliente: async ({ commit }, _id) => service.readSubscriptionsByCliente(_id).then(result => commit('SET_LIST', result)),
  deleteSubscriptions: ({ commit, rootState }, { input, isDelete }) =>
    service.deleteSubscriptions({ _id: rootState.cliente.clienteStore.cliente._id, input, isDelete }).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', { i, isDelete })
      })
      return result
    }),

  readBitacora: ({ commit, rootState }, _id) => {
    service.readBitacora(_id, rootState.cliente.clienteStore.cliente._id).then(result => commit('SET_BITACORA', result))
  },

  updateSubscription: ({ state, rootState }) => {
    const { _id, freq, next } = state.subscription
    service.updateSubscription(_id, rootState.cliente.clienteStore.cliente._id, next, freq)
  }
}
